import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { NavigationService } from "../../services/navigation.service";

@Component({
  selector: "app-breadcrumb",
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: "./breadcrumb.component.html",
  styleUrl: "./breadcrumb.component.scss",
})
export class BreadcrumbComponent {
  breadcrumbs: { label: string; url?: string }[] = [];
  pageInfo;
  fromPage: any;
  booking_pet_id: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private navigation: NavigationService
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === "primary"),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => {
        this.titleService.setTitle(event["title"]);
        this.pageInfo = event;
        this.checkBreadcrumbForUrl();
      });
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.activatedRoute.queryParams.subscribe((params) => {
      this.fromPage = params["from"];
      this.booking_pet_id = params["booking_pet_id"];
    });
  }

  checkBreadcrumbForUrl() {
    for (const index in this.pageInfo.urls) {
      if (this.pageInfo.urls[index].url) {
        if (this.pageInfo.urls[index].url.includes(":")) {
          this.pageInfo.urls[index]["isDynamic"] = true;

          // only for dashboard. When we come from dashboard to medication detail page then should go to booking detail page on click booking detail breadcrumb
          if (this.fromPage == "dashboard") {
            this.pageInfo.urls[index]["isDynamic"] = false;
            this.pageInfo.urls[
              index
            ].url = `/booking/detail/${this.booking_pet_id}`;
          }
          // end
        }
      }
    }
  }

  redirectToPage(url) {
    this.router.navigate([url.url]);
  }
  redirectBack() {
    this.navigation.back("");
  }
}
